/**
 * Removes `prefix` from the start of `value`; returns `value` unchanged when it does not start with it.
 *
 * @example
 * removePrefix('000000-123/0100', '000000-'); // '123/0100'
 */
export function removePrefix(value: string, prefix: string): string {
  return value.startsWith(prefix) ? value.slice(prefix.length) : value;
}
